export class Game {
    public constructor() {
        this.GameId = 0;
        this.IsChanged = false;
        this.RealGoalsTeam1 = 0;
        this.RealGoalsTeam2 = 0;
        this.Status = 0;
    }

    public Team1: string;
    public Team2: string;
    public GameId: number;
    public IconTeam1: string;
    public IconTeam2: string;
    public RealGoalsTeam1: number;
    public RealGoalsTeam2: number;
    public Schedule: Date;
    public ScheduleString: string;
    public Status: number;
    public IsScheduleChecked: boolean;
    public IsChanged: boolean;
}


// WEBPACK FOOTER //
// ./src/entities/game.ts